// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Події» (Events, ключ `event`, група `communications`). */
export const eventsManifest: IModuleManifest = {
  key: 'event',
  group: 'communications',
  slug: 'events',
  prefix: 'EVT',
  name: { en: 'Events', uk: 'Події' },
  entities: [
    { key: 'event', slug: 'event', name: { en: 'Events', uk: 'Події' }, main: true },
    { key: 'event_guest', slug: 'event-guest', name: { en: 'Event Guests', uk: 'Гості' }, main: false },
    { key: 'event_registration', slug: 'event-registration', name: { en: 'Event Registrations', uk: 'Реєстрації' }, main: false },
    { key: 'event_programme_item', slug: 'event-programme-item', name: { en: 'Event Programme Items', uk: 'Пункти програми' }, main: false },
    { key: 'event_venue', slug: 'event-venue', name: { en: 'Event Venues', uk: 'Місця проведення' }, main: false },
    { key: 'event_status', slug: 'event-status', name: { en: 'Event Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/eventsSlice').then((m) => m.eventsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
